module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0004-5681a4c5e49a41104e08baac32aa3a46.jpg";